module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKUAAAAeAgMAAAAwSDb/AAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAlQTFRFAAAA////////c3ilYwAAAAN0Uk5TAGf//cjWMwAAAEdJREFUeJxjkFrJkLWEcdUEtlUO+JkMDFmrHFetZFu1RGrVBPxMBoZVq5pWreJatUJr1QL8zFGlo0pHlY4qJUkpCQUR8cUbAJLujb+VCt7CAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/halfLevel.png
// module id = 582
// module chunks = 0